import * as React from "react";
import {cx} from "emotion";

import "./acknowledge.scss";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Static2}          from "@Common/react/static-2";
import {UseState}         from "@Common/react/use-state";
import {Checkbox}         from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {AgreementModal} from "../../../../common/agreement-modal/agreement-modal";

export const Acknowledge = ({next}) => cs(
    consumeContext("apis"),
    ["agreed", (_, next) => UseState({next})],
    ["domRef", (_, next) => Static2({next})],
    ["errorHighlighter", (_, next) => ErrorHighlighter({next})],
    ["agreementModal", ({agreed}, next) => AgreementModal({next, agree: () => agreed.onChange(true)})],
    ({errorHighlighter, agreed, agreementModal, domRef}) => next({
        invalid: agreementModal.available && !agreed.value,
        highlightErrors: () => {
            errorHighlighter.start();
            scrollIntoView(domRef.get());
        },
        render: ({showErrors}) => agreementModal.available && cs(
            ({}, next) => (
                <div
                    className={cx("acknowledge-35d", {hasError: showErrors && !agreed.value}, errorHighlighter.css)}
                    ref={domRef.set}
                >
                    {next()}
                </div>
            ),
            ({}) => (
                <div {...{
                    className: cx("agree"),
                    onClick: () => agreed.change((_) => !_)
                }}>
                    {Checkbox({checked: agreed.value, xdQaName: "I agree and understand my responsibility"})}

                    <div className="label">
                        I agree and{" "}
                        <a
                            xd-qa-type="link" 
                            xd-qa-name="understand my responsibility"
                            onClick={(e) => {
                                e.stopPropagation();
                                agreementModal.show();
                            }}
                        >
                            understand my responsibility
                        </a>
                    </div>
                </div>
            ),
        ),
    }),
);
